import { useCallback } from "react";
import { useDispatch } from 'react-redux';
import {
    presignedUrlGenerationStart,
    presignedUrlGenerationComplete
} from '../redux/actions/fileUpload';

const usePresignedUrlCount = () => {
    const dispatch = useDispatch();

    const incrementPresignedUrlCount = useCallback((count = 1) => {
        dispatch(presignedUrlGenerationStart(count));
    }, [dispatch]);

    const decrementPresignedUrlCount = useCallback((count = 1) => {
        dispatch(presignedUrlGenerationComplete(count));
    }, [dispatch]);

    return {
        incrementPresignedUrlCount,
        decrementPresignedUrlCount
    }
}

export default usePresignedUrlCount;